<script>
// import axios from "axios";
import router from "@/router";
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';

export default {
  page: {
    title: "Volunteer System",
    meta: [
      {
        name: "Volunteer System",
      },
    ],
  },
  components: {Header , Footer},
  data(){
    return{
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      userData : JSON.parse(localStorage.getItem('web_user')),
      is_volunteer:false,
    }
  },
  methods:{
      gotomntcOrg(){
        window.open("https://www.mntc.org/");
      },
      gotoHomePage(){
        router.push({ name: 'volunteer-system'});
      }
  },
  mounted(){
    // if(this.userData.user_type_id == 4){
    //   this.is_volunteer = true;
    // }
  }

}
</script>

<template>
  <div>
    <Header></Header>
    <div id="main-title" class="secondary">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6 align-self-center">
            <h3 class="title" > Thank You</h3>
          </div>
          <div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
            <p class="need-help">Need Help ? <a href="javascript:">Contact Us</a> </p>
          </div>
        </div>
      </div>
    </div>
    <div id="create-account">
      <div class="container custom-form">
          <div class="row">
            <div class="col-12 mb-5">
              <h3 class="main-title">Character Reference Submitted</h3>
            </div>
          </div>

        <!-- if volunteer -->
        <div class="row modal-body" id = "mntc_thankyou_page_content">
            <div class="col-12">
            <p class="pb-0">Thank you for completing Character Reference.</p>
            <div class="d-flex justify-content-center mb-5">
                <b-button type="button" @click="gotoHomePage" variant="custom">Return to Homepage</b-button>
                <b-button type="button" @click="gotomntcOrg" variant="custom">Visit MNTC.ORG</b-button>
            </div>
            </div>
        </div>

      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<style scoped>
    #mntc_thankyou_page_content p{
        font-size: 16px!important;
        text-align: center;
        text-transform: unset !important;
}

    #mntc_thankyou_page_content h4{
        color: #495057;
        font-size: 24px;
        text-align: center;
    }

</style>